<script>
import EmptyPerson from '@asar-studio/rusdram-svgs/dist/illustrations/unkown-person.svg'

export default {
  props: {
    to: {
      type: String,
      default: () => null
    },
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    imgUuid: {
      type: String,
      default: () => ''
    }
  },
  setup() {
    return { EmptyPerson }
  }
}
</script>

<template>
  <article
    class="cursor-pointer flex flex-col space-y-2 pl-4 pr-3"
    @click="$router.push(to)"
  >
    <header class="rounded-xl overflow-hidden h-48">
      <img
        loading="lazy"
        class="w-full h-full object-cover bg-gray-200"
        :src="
          imgUuid
            ? `https://ucarecdn.com/${imgUuid}/-/format/webp/-/scale_crop/380x380/center/image.webp`
            : EmptyPerson
        "
        :alt="name"
      />
    </header>
    <div class="text-center flex flex-col space-y-1">
      <p class="font-sans text-lg text-primary">{{ title }}</p>
      <p class="font-sans text-lg text-dark-gray">{{ name }}</p>
    </div>
  </article>
</template>
